<div class="empty-state">
  <div class="empty-state-icon">
    <app-titan-icon [variant]="'Sparks'" [size]="'xl'" class="color-orange-500"></app-titan-icon>
  </div>
  <h3 class="empty-state-title">Audience AI Assistant</h3>
  <p class="empty-state-description">
    Describe your target audience and I'll help you build the perfect targeting criteria.
  </p>

  <div class="example-prompts">
    <p class="example-prompts-label">TRY ASKING:</p>
    <div class="example-prompts-list">
      <button
        *ngFor="let prompt of examplePrompts"
        class="example-prompt"
        (click)="onPromptClick(prompt)"
        type="button">
        {{ prompt }}
      </button>
    </div>
  </div>
</div>
